export abstract class BaseEvent {
    get payload(): any { return this._payload; }

    private _payload: any;

    constructor (payload?: any) {
        this._payload = payload;
    }
}
